<template>
	<div class="dynamic-duration">{{ localDuration | timecode }}</div>
</template>

<script>
export default {
	name: "DynamicDuration",
	props: {
		duration: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			localDuration: 0
		};
	},
	computed: {
		// update localStart on each sessionstatus poll in case local clock changes
		localStart() {
			return Date.now() / 1000 - this.duration;
		}
	},
	mounted() {
		this.durationInterval = setInterval(() => {
			this.localDuration = Math.ceil(Date.now() / 1000) - this.localStart;
		}, 1000);
	},
	beforeDestroy() {
		clearInterval(this.durationInterval);
	}
};
</script>
